<skl-dialog-content-ins [isReady]="viewModel.isFormReady">
    <skl-dialog-header-ins
        [title]="'scenes.configuration.shared.mail-template.dialog.title' | translate"
        id="mail-template-dialog-header"
        (onClose)="onCancel()">
    </skl-dialog-header-ins>

    <ins-content>
        @if (viewModel.isFormReady) {
            <skl-form-container>
                <div [sklValidationSource]="viewValidation">
                    <ins-tab-group>
                        <ins-tab-bar
                            slot="top"
                            [selectedTab]="viewModel.parametersAreaId">
                            <ins-tab-button [tab]="viewModel.parametersAreaId" id="mail-template-dialog-parameters-tab">
                                {{ 'scenes.configuration.shared.mail-template.dialog.tabs.parameters' | translate }}
                                <skl-validation-area class="align--tiny-left" [areaId]="viewModel.parametersAreaId"></skl-validation-area>
                            </ins-tab-button>
                            <ins-tab-button [tab]="viewModel.patternAreaId" id="mail-template-dialog-pattern-area-tab">
                                {{ 'scenes.configuration.shared.mail-template.dialog.tabs.pattern' | translate }}
                                <skl-validation-area class="align--tiny-left" [areaId]="viewModel.patternAreaId"></skl-validation-area>
                            </ins-tab-button>
                        </ins-tab-bar>
                        <ins-tab
                            [attr.validation-area-id]="viewModel.parametersAreaId"
                            [tab]="viewModel.parametersAreaId">
                            <div
                                class="align--medium-top align--medium-bottom">
                                <ins-checkbox
                                    id="mail-template-dialog-default"
                                    class="align--medium-top"
                                    [(ngModel)]="viewModel.bo.model.default"
                                    [label]="'scenes.configuration.shared.mail-template.dialog.form.default.label' | translate"
                                    [sklValidate]="getValidationKey('default')">
                                </ins-checkbox>
                                <ins-form-field
                                    [skl-focus-by]
                                    [label]="'scenes.configuration.shared.mail-template.dialog.form.kind.label' | translate">
                                    <ins-select
                                        display-text="label"
                                        id="mail-template-dialog-kind"
                                        [placeholder]="'ui.placeholders.empty' | translate"
                                        [converter]="viewModel.mailTemplateTypesConverter"
                                        [(ngModel)]="viewModel.bo.model.kind"
                                        [sklValidate]="getValidationKey('kind')">
                                        @for (item of viewModel.mailTemplateTypes; track item) {
                                            <ins-option
                                                [value]="item">
                                                {{item.label}}
                                            </ins-option>
                                        }
                                    </ins-select>
                                </ins-form-field>
                                <ins-form-field
                                    [label]="'scenes.configuration.shared.mail-template.dialog.form.name.label' | translate">
                                    <ins-input
                                        [(ngModel)]="viewModel.bo.model.name"
                                        id="mail-template-dialog-name"
                                        [placeholder]="'scenes.configuration.shared.mail-template.dialog.form.name.placeholder' | translate"
                                        [sklValidate]="getValidationKey('name')">
                                    </ins-input>
                                </ins-form-field>
                                <ins-form-field
                                    [label]="'scenes.configuration.shared.mail-template.dialog.form.sender-name.label' | translate">
                                    <ins-input
                                        [fill-empty]="viewModel.senderNamePlaceholder"
                                        id="mail-template-dialog-sender-name"
                                        [(ngModel)]="viewModel.senderName.value"
                                        [placeholder]="'scenes.configuration.shared.mail-template.dialog.form.sender-name.placeholder' | translate"
                                        [sklValidate]="getValidationKey('senderName')">
                                    </ins-input>
                                </ins-form-field>
                            </div>
                        </ins-tab>
                        <ins-tab
                            [attr.validation-area-id]="viewModel.patternAreaId"
                            [tab]="viewModel.patternAreaId">
                            @if (!viewModel.isEditingTemplateActive) {
                                <span class="message-box-info align--small">
                                    <skl-icon name="info" size="16px"></skl-icon>
                                    <div>{{'scenes.configuration.shared.mail-template.messages.editing-unavailable' | translate}}</div>
                                </span>
                            }
                            <div class="align--medium-top align--medium-bottom">
                                <ins-form-field
                                    [label]="'scenes.configuration.shared.mail-template.dialog.form.subject.label' | translate">
                                    <ins-input
                                        [(ngModel)]="viewModel.bo.model.subjectPattern"
                                        id="mail-template-dialog-subject-pattern"
                                        [placeholder]="'scenes.configuration.shared.mail-template.dialog.form.subject.placeholder' | translate"
                                        [disabled]="!viewModel.isEditingTemplateActive"
                                        [sklValidate]="getValidationKey('subjectPattern')">
                                    </ins-input>
                                    <div slot="end">
                                        <skl-help-in-place [data]="viewModel.getMailTemplateAutotextsHintobxData()"></skl-help-in-place>
                                    </div>
                                </ins-form-field>

                                <ins-form-field
                                    [label]="'scenes.configuration.shared.mail-template.dialog.form.content.label' | translate">
                                    <ins-textarea
                                        rows="10"
                                        id="mail-template-dialog-message-pattern"
                                        [(ngModel)]="viewModel.bo.model.messagePattern"
                                        [placeholder]="'scenes.configuration.shared.mail-template.dialog.form.content.placeholder' | translate"
                                        [disabled]="!viewModel.isEditingTemplateActive"
                                        [sklValidate]="getValidationKey('messagePattern')">
                                    </ins-textarea>
                                    <div slot="end">
                                        <skl-help-in-place [data]="viewModel.getMailTemplateAutotextsHintobxData()"></skl-help-in-place>
                                    </div>
                                </ins-form-field>
                            </div>
                        </ins-tab>
                    </ins-tab-group>
                </div>
            </skl-form-container>
        }
    </ins-content>

    <ins-footer class="dialog__buttons">
        <skl-button
            id="mail-template-dialog-cancel-button"
            (click)="onCancel()">
            {{ 'scenes.configuration.shared.base.dialog.buttons.cancel' | translate }}
        </skl-button>
        <skl-button
            typeName="accent"
            id="mail-template-dialog-save-button"
            [spinner]="viewModel.isSaving"
            (click)="onConfirmAsync()">
            {{ 'scenes.configuration.shared.base.dialog.buttons.save' | translate }}
        </skl-button>
    </ins-footer>
</skl-dialog-content-ins>
